import React, { useState } from "react";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import SwitchToggle from "../../components/SwitchToggle";

const ManageDispatcher = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // Sample program data
  const programs = [
    {
      id: "PROG001",
      title: "Full Body Transformation",
      thumbnail: "/static/images/program_placeholder.png",
      duration: "12 Weeks",
      difficulty: "Intermediate",
      enrolledUsers: 45,
      goals: "Strength, Stamina",
      equipment: "Dumbbells, Mat",
    },
    {
      id: "PROG002",
      title: "HIIT Blast",
      thumbnail: "/static/images/program_placeholder.png",
      duration: "6 Weeks",
      difficulty: "Advanced",
      enrolledUsers: 30,
      goals: "Fat Loss, Endurance",
      equipment: "None",
    },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Manage Programs</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Programs
        </p>
      </div>

      <div className="cards">
        {/* Header with Search and Add Button */}
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Programs"
            />
          </div>

          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("add")}>
              <AddIcon /> Add Program
            </Button>
          </div>
        </div>

        {/* Table */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Program Details</TableCell>
                <TableCell>Duration</TableCell>
                <TableCell>Difficulty</TableCell>
                <TableCell>Enrolled Users</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {programs.map((program) => (
                <TableRow hover key={program.id}>
                  {/* ID */}
                  <TableCell>{program.id}</TableCell>

                  {/* Program Details */}
                  <TableCell>
                    <div className="user_block">
                      <figure>
                        <img
                          src={program.thumbnail}
                          alt={program.title}
                          style={{ objectFit: "contain" }}
                        />
                      </figure>
                      <p>
                        <b>{program.title}</b>
                        <span>Goals: {program.goals}</span>
                        <span>Equipment: {program.equipment}</span>
                      </p>
                    </div>
                  </TableCell>

                  {/* Duration */}
                  <TableCell>{program.duration}</TableCell>

                  {/* Difficulty */}
                  <TableCell>{program.difficulty}</TableCell>

                  {/* Enrolled Users */}
                  <TableCell>{program.enrolledUsers}</TableCell>

                  {/* Actions */}
                  <TableCell>
                    <div className="table_actions v2">
                      {/* <a
                        href="view-program"
                        className="btn btn_primary sm"
                      >
                        View
                      </a> */}
                      <IconButton>
                        <img
                          onClick={() => navigate("view")}
                          src="/static/images/eye_icon.svg"
                          alt="View"  
                        />
                      </IconButton>
                      <IconButton
                        onClick={() => navigate("edit", { state: { program } })}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>

                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageDispatcher;
